import { createAction } from 'redux-actions';

import { FETCH_TABLES_START, SET_TABLES } from './constants';

export const fetchTable = createAction(
	FETCH_TABLES_START,
	(token: string) => ({ token }),
);

export const setTable = createAction(
	SET_TABLES,
	(tables: string) => ({ tables }),
);
